module.exports = __webpack_public_path__ + "img/ippy-logo.67e5f91.png";